interface Props {
    message?: string;
    opacity?: number; // 0-100, default 80
}

export default function LoadingSkeleton({ message, opacity = 80 }: Props) {
    // Clamp opacity between 0 and 100
    const overlayOpacity = Math.max(0, Math.min(100, opacity));
    return (
        <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center w-full min-h-screen">
            {/* Overlay for blue/dark obfuscation */}
            <div
                className="absolute inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-black pointer-events-none z-[9998]"
                style={{ opacity: overlayOpacity / 100 }}
            />
            <div className=" h-20 relative z-[10000] grid w-full place-items-center overflow-x-scroll rounded-lg p-6 lg:overflow-visible">
                {/* Modern flipping loader (Harvey Red, 4 squares, padded) */}
                <div className="loader">
                </div>
            </div>
            <p className="relative z-[10000] text-harvey-red/80 mt-4 text-lg tracking-wide animate-pulse">{message}</p>
        </div>
    );
}

// Main portal loading skeleton for first load excitement
export function LoadingSkeletonMain() {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen w-full bg-gradient-to-br from-harvey-red via-red-800 to-black animate-gradient-x">
            <div className=" h-20 relative z-[10000] grid w-full place-items-center overflow-x-scroll rounded-lg p-6 lg:overflow-visible">
                {/* Modern flipping loader (Harvey Red, 4 squares, padded) */}
                <div className="loader">
                </div>
            </div>
            <div className="mt-10 text-center">
                <h1 className="text-3xl md:text-4xl font-extrabold text-harvey-red mb-2 animate-fade-in">Getting things ready for you...</h1>
                <p className="text-harvey-red/90 text-lg md:text-xl font-medium animate-fade-in-slow">Our team of digital hamsters is spinning up your experience! 🐹✨</p>
                <div className="mt-8 flex flex-col items-center gap-2 animate-fade-in-slow">
                    <span className="text-red-300 text-base">Loading progress: <span className="font-mono">[████████░░░░]</span></span>
                    <span className="text-red-400 text-xs italic">Tip: For best results, keep your browser snacks (cookies) enabled 🍪</span>
                </div>
            </div>
        </div>
    );
}